import { render, staticRenderFns } from "./BulkSchemaMapping.vue?vue&type=template&id=5f770d82&scoped=true"
import script from "./BulkSchemaMapping.vue?vue&type=script&lang=ts"
export * from "./BulkSchemaMapping.vue?vue&type=script&lang=ts"
import style0 from "./BulkSchemaMapping.vue?vue&type=style&index=0&id=5f770d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f770d82",
  null
  
)

export default component.exports